import styled from 'styled-components';

import Toggle from '../../../_shared/components/Toggle';

export const StyledConditionFilter = styled.ul`
  height: auto;
  border-bottom: 1px solid ${({ theme }) => theme.COLORS.LIGHT_SILVER};
  padding-top: 25px;
`;

export const StyledCondition = styled.li`
  display: flex;
  flex-direction: row;
  padding-bottom: 18px;
  align-items: center;
`;

export const Label = styled.div`
  max-width: 149px;
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
`;

export const StyledToggle = styled(Toggle)`
  margin-left: auto;
`;
